// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"globalstartpage_mainHeader__Bq_W_","body":"globalstartpage_body__mvdrc"};